const baselightTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#b48a62',
      light: '#f7f2ec',
      dark: '#8f6844',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#2A3547',
      light: '#F2F6FA',
      dark: '#1e2633',
      contrastText: '#ffffff',
    },
    success: {
      main: '#13DEB9',
      light: '#E6FFFA',
      dark: '#02b3a9',
      contrastText: '#ffffff',
    },
    info: {
      main: '#539BFF',
      light: '#EBF3FE',
      dark: '#1682d4',
      contrastText: '#ffffff',
    },
    error: {
      main: '#FA896B',
      light: '#FDEDE8',
      dark: '#f3704d',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FFAE1F',
      light: '#FEF5E5',
      dark: '#ae8e59',
      contrastText: '#ffffff',
    },
    purple: {
      A50: '#EBF3FE',
      A100: '#6610f2',
      A200: '#557fb9',
    },
    grey: {
      50: '#F8FAFC',
      100: '#F2F6FA',
      200: '#EAEFF4',
      300: '#DFE5EF',
      400: '#CBD5E1',
      500: '#5A6A85',
      600: '#2A3547',
    },
    text: {
      primary: '#2A3547',
      secondary: '#5A6A85',
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.04,
      hover: '#f6f9fc',
    },
    divider: '#e5eaef',
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
  },
};

const baseDarkTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#b48a62',
      light: '#2d251d',
      dark: '#8f6844',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#777e89',
      light: '#1C455D',
      dark: '#173f98',
      contrastText: '#ffffff',
    },
    success: {
      main: '#13DEB9',
      light: '#1B3C48',
      dark: '#02b3a9',
      contrastText: '#ffffff',
    },
    info: {
      main: '#539BFF',
      light: '#223662',
      dark: '#1682d4',
      contrastText: '#ffffff',
    },
    error: {
      main: '#FA896B',
      light: '#4B313D',
      dark: '#f3704d',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FFAE1F',
      light: '#4D3A2A',
      dark: '#ae8e59',
      contrastText: '#ffffff',
    },
    purple: {
      A50: '#EBF3FE',
      A100: '#6610f2',
      A200: '#557fb9',
    },
    grey: {
      100: '#333F55',
      200: '#465670',
      300: '#e7e7e7',
      400: '#DFE5EF',
      500: '#EAEFF4',
      600: '#F2F6FA',
      A700: '#465670',
    },
    text: {
      primary: '#EAEFF4',
      secondary: '#94a3b8',
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.04,
      hover: '#333F55',
    },
    divider: '#333F55',
    background: {
      default: '#171c23',
      dark: '#11151b',
      paper: '#1e242d',
    },
  },
};

export { baseDarkTheme, baselightTheme };
